import Config from "@/store/modules/config";
import i18n from "@/i18n";

class Notification {

    create(title, text) {
        let notificationNode        = document.createElement('p');
        notificationNode.innerHTML  = title;

        if (typeof text === 'string' && text !== '') {
            notificationNode.innerHTML += "<small>" + text + "</small>";
        }

        let mainBoxNode = this.getMainBoxNode()
        mainBoxNode.appendChild(notificationNode);
    }

    getMainBoxNode() {
        let mainBoxNode = document.getElementById('app-notification-main');

        if (mainBoxNode === null) {
            mainBoxNode         = document.createElement('div');
            mainBoxNode.id      = "app-notification-main";

            let closeNode       = document.createElement('img');
            closeNode.src       = Config.getters.getAppUrl + '/img/icons/close-dark.svg';
            closeNode.className = 'close';
            closeNode.addEventListener('click', function () {
                mainBoxNode.remove();
            });
            mainBoxNode.appendChild(closeNode);

            mainBoxNode.addEventListener('click', function () {
                mainBoxNode.remove();
            });

            let headerNode          = document.createElement('h5');
            headerNode.innerHTML    = i18n.t('Notifications.title');
            mainBoxNode.appendChild(headerNode);

            let body = document.getElementById('app-notification');
            body.appendChild(mainBoxNode);
        }

        return mainBoxNode;
    }
}

export default new Notification();